export enum FilterVariant {
  Select = "Select",
  MultiSelect = "MultiSelect",
  Text = "Text",
  Number = "Number",
}

export enum FilterType {
  Is = "Is",
  IsNot = "Is not",
  Contains = "Contains",
  NotContains = "Does not contain",
  GreaterThan = "Greater than",
  LowerThan = "Lower than",
}

export type FilterValue = {
  filterType: FilterType
  value: string
}

export type FilterEntry = {
  id: string
  value: FilterValue[]
}

export interface FilterProperty {
  id: string
  label: string
  filterVariant: FilterVariant
  filterOptions?: string[]
  filterOptionLabels?: Record<string, string>
  filterTypes?: FilterType[]
}

export const getFilterTypesByFilterVariant = (type?: FilterVariant) => {
  switch (type) {
    case FilterVariant.Select:
      return [FilterType.Is, FilterType.IsNot]
    case FilterVariant.Text:
      return [FilterType.Is, FilterType.IsNot, FilterType.Contains, FilterType.NotContains]
    case FilterVariant.Number:
      return [FilterType.Is, FilterType.IsNot, FilterType.GreaterThan, FilterType.LowerThan]
    default:
      return [FilterType.Is, FilterType.IsNot]
  }
}
